import {env} from '../package.json'

const prefix = env === 'production' ? 'https://museum-voice.bowu66.com' : ''

export default {
    entry: `${prefix}/api/guide/getMuseumDetail`,
    list: `${prefix}/api/guide/getExhibitsGuideList`,
    detail: `${prefix}/api/guide/getExhibitsGuideDetail`
}
